// @ts-ignore
import UnreadStore from 'stores/UnreadStore';
// @ts-ignore
import AuthActions from 'auth/AuthActions';
import { InjectedRouter } from 'react-router';

/**
 * The object for inter-process communication within Electron.
 *
 * `window.require` is defined by Electron when nodeIntegration: true
 * @see https://github.com/atom/electron/blob/master/docs/api/browser-window.md
 * @return {IPC} https://github.com/atom/electron/blob/master/docs/api/ipc-renderer.md
 */
function getIpc() {
  if (isAvailable()) {
    return (window as any).require('electron').ipcRenderer;
  } else {
    throw new Error('Electron not available');
  }
}

/**
 * Receive each IPC message that the Electron desktop app sends.
 *
 * NOTE: NEVER REMOVE A BINDING DEFINED HERE. That would break installed
 * versions of the desktop app and unlike web we can't auto-update. Instead,
 * if a function can no longer be implemented, notify the user with an alert.
 */
function bindReceivers(ipc: any, router: InjectedRouter) {
  ipc.on('show-classes', () => {
    router.push('/classes');
  });

  ipc.on('show-chat', () => {
    router.push('/inbox');
  });

  ipc.on('show-settings', () => {
    router.push('/settings');
  });

  ipc.on('new-conversation', () => {
    router.push('/classes/r/messages/new');
  });

  ipc.on('log-out', () => {
    AuthActions.signOut();
  });
}

function bindSenders(ipc: any) {
  UnreadStore.addChangeListener(() =>
    ipc.send('set-app-unread-count', UnreadStore.getTotalUnread())
  );
}

function bindIfAvailable(router: InjectedRouter) {
  if (isAvailable()) {
    const ipc = getIpc();
    bindReceivers(ipc, router);
    bindSenders(ipc);
  }
}

function isAvailable(): boolean {
  return !!(
    typeof window !== 'undefined' &&
    (window as any).require &&
    (window as any).require.extensions && // test for Node's require, not just any window.require
    (window as any).require('electron')
  ); // b/c some malware defines window.require that throws here
}

function showCurrentWindow() {
  (window as any)
    .require('electron')
    .remote.getCurrentWindow()
    .show();
}

export default {
  bindIfAvailable,
  bindReceivers,
  bindSenders,
  isAvailable,
  showCurrentWindow,
};
